// extracted by mini-css-extract-plugin
export default {"navBar":"App_navBar__G8MGg"};